let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("52893")).then(() => parcelRequire('fbrgk'));